const BlurModal = () => {
  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      style={{
        display: "block"
      }}
      aria-labelledby="exampleModalLabel"
      aria-hidden="false"
    >
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div class="blur-container">
          <div class="blur-box">
          <h2 className="blur_loading_text">Fecthing Data.....</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlurModal;
